import { render, staticRenderFns } from "./ScreenYs.vue?vue&type=template&id=25603500&scoped=true"
import script from "./ScreenYs.vue?vue&type=script&lang=js"
export * from "./ScreenYs.vue?vue&type=script&lang=js"
import style0 from "./ScreenYs.vue?vue&type=style&index=0&id=25603500&prod&lang=css"
import style1 from "./ScreenYs.vue?vue&type=style&index=1&id=25603500&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25603500",
  null
  
)

export default component.exports